<template>
  <div class="d-flex f-wrap mt-auto">
    <template v-if="window.width >= 768">
      <button :id="getCountryId()" class="btn btn-md btn-yellow mr-12">
        Pokaż na mapie
      </button>
      <a :href="offersUrl" class="btn btn-md btn-d-blue mr-12">
        Oferty na wakacje
      </a>
      <a :href="geoUrl" class="btn btn-md btn-d-blue">Przewodnik</a>
    </template>
    <template v-if="window.width < 768">
      <a :href="offersUrl" class="btn btn-md btn-d-blue mr-12">
        Oferty na wakacje
      </a>
      <a-popover
        placement="topRight"
        v-model="visible"
        :title="false"
        trigger="click"
      >
        <template #content>
          <a :href="geoUrl" class="btn btn-md btn-d-blue d-block mb-12"
            >Przewodnik</a
          >
          <button :id="getCountryId()" class="btn btn-md btn-yellow">
            Pokaż na mapie
          </button>
        </template>
        <button class="btn btn-md-icon btn-gray">
          <a-icon type="ellipsis" class="font-24" />
        </button>
      </a-popover>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    offersUrl: String,
    geoUrl: String,
    regionAbbr: String,
  },
  data: () => ({
    window: {
      width: 0,
      height: 0,
    },
    visible: false,
  }),
  methods: {
    hide() {
      this.visible = false;
    },
    getCountryId() {
      // Warunek dla Izraela ze względu na rozbieżność pomiędzy kodem na portalu (IZ),
      // a obowiązującym wg ISO 3166 (IL), używanym przez plugin "jvectormap".
      let israelIsoAbbr = "";
      if (this.regionAbbr === "iz") {
        israelIsoAbbr = "il";
        return israelIsoAbbr;
      } else {
        return this.regionAbbr;
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize, { passive: true });
    this.handleResize();
  },
};
</script>
